export default "__VITE_ASSET__VpwPy6lY__"